<div fxLayout="column">
    <h1 class="mat-headline" fxLayoutAlign="center center">{{pageInfo.title}}</h1>
    <mat-progress-bar mode="indeterminate" *ngIf="!isCompleted"></mat-progress-bar>
    <ng-container *ngIf="isCompleted">
        <div style="margin-top: 30px;" [innerHTML]="pageInfo.content"></div>
    </ng-container>
</div>